import { Button, Container, Notice, Separator, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ACCOUNT } from '../Routes';
import useStores from '../stores/UseStores';

interface DuplicateProfileNoticeProps {
  message: string;
}

const DuplicateProfileNotice = observer((props: DuplicateProfileNoticeProps): React.JSX.Element => {
  const { message } = props;
  const {
    translateStore: { translate },
    routeStore,
  } = useStores();

  return (
    <Container>
      <Notice type="error">
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </Notice>
      <Separator color="invisible" spacing="small" />
      <Text className="text-center">
        <Button onClick={routeStore.navigate} url={`${ACCOUNT}${routeStore.formForwardParams}`} text={translate('button.back')} iconRight="#arrow-right" />
      </Text>
    </Container>
  );
});

export default DuplicateProfileNotice;
